var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2017 4.38811C9.63155 3.87584 8.76689 3.87584 8.19672 4.38811L2.69672 9.32965C2.38008 9.61414 2.19922 10.0198 2.19922 10.4454V17.4996C2.19922 18.328 2.87079 18.9996 3.69922 18.9996H5.69922C6.52765 18.9996 7.19922 18.328 7.19922 17.4996V13.4996C7.19922 13.2234 7.42308 12.9996 7.69922 12.9996H10.6992C10.9754 12.9996 11.1992 13.2234 11.1992 13.4996V17.4996C11.1992 18.328 11.8708 18.9996 12.6992 18.9996H14.6992C15.5276 18.9996 16.1992 18.328 16.1992 17.4996V10.4454C16.1992 10.0198 16.0184 9.61414 15.7017 9.32965L10.2017 4.38811Z",
    fill: "#342C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/HomeFilled.31ba6aa941e246471b18904bf860320d.svg";
export { ForwardRef as ReactComponent };